const formSections = {
  PATIENT_SECTION: "patient",
  CONSENT_SECTION: "consent"
};

export { formSections };
